import axios from 'axios';

export function get(url, params = {}) {
  setData();
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
    .then(response => {
      if (response) {
        resolve(response.data);
      } else {
        return Promise.reject(new Error('接口数据请求或返回异常'));
      }
    })
    .catch(err => {
      reject(err);
    });
  });
}

export function post(url, data = {}, config = {}) {
  setData();
  return new Promise((resolve, reject) => {
    axios.post(url, data, config)
      .then(response => {
        if (response) {
          resolve(response.data);
        } else {
          return Promise.reject(new Error('接口数据请求或返回异常'));
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function getDelete(url, params = {}) {
  setData();
  return new Promise((resolve, reject) => {
    axios.delete(url, {
      params: params
    })
        .then(response => {
          if (response) {
            resolve(response.data);
          } else {
            return Promise.reject(new Error('接口数据请求或返回异常'));
          }
        })
        .catch(err => {
          reject(err);
        });
  });
}

export function postDelete(url, data = {}, config = {}) {
  setData();
  return new Promise((resolve, reject) => {
    axios.delete(url, data, config)
        .then(response => {
          if (response) {
            resolve(response.data);
          } else {
            return Promise.reject(new Error('接口数据请求或返回异常'));
          }
        })
        .catch(err => {
          reject(err);
        });
  });
}

export function postPut(url, data = {}, config = {}) {
  setData();
  return new Promise((resolve, reject) => {
    axios.put(url, data, config)
        .then(response => {
          if (response) {
            resolve(response.data);
          } else {
            return Promise.reject(new Error('接口数据请求或返回异常'));
          }
        })
        .catch(err => {
          reject(err);
        });
  });
}

export function download(url, data = {}) {
  setData();
  return new Promise((resolve, reject) => {
    axios({
      url,
      methods: 'get',
      params: data,
      responseType: 'blob'
    }).then(response => {
        if (response) {
          resolve(response.data);
        } else {
          return Promise.reject(new Error('接口数据请求或返回异常'));
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 注入公共参数
function setData() {
}
